import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { DetailedCitizenProceduresIndicatorB3 } from "@/services/esus/indicator/esb/b3/getDetailedCitizenProceduresIndicatorB3";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsbB3DentalAttendanceProceduresHistoryItem } from "./IndicatorEsbB3DentalProcedureHistoryItem";
import { IndicatorEsbB3CitizenHistoryInfo } from "./IndicatorEsbB3CitizenHistoryInfo";
import { timeDimensionToString } from "@/utils/dateUtil";

type IndicatorEsbB3CitizenAttendancesHistoryProps = {
	citizenWithDentalAttendanceProcedures: DetailedCitizenProceduresIndicatorB3;
};

export function IndicatorEsbB3CitizenAttendancesHistory({
	citizenWithDentalAttendanceProcedures,
}: Readonly<IndicatorEsbB3CitizenAttendancesHistoryProps>) {
	const indicatorEsbB3CitizenHistoryInfo = {
		fullName: citizenWithDentalAttendanceProcedures.fullName
			? citizenWithDentalAttendanceProcedures.fullName
			: "N/A",
		birthdate: citizenWithDentalAttendanceProcedures.birthdate
			? dayjs(citizenWithDentalAttendanceProcedures.birthdate).format("DD/MM/YYYY")
			: "N/A",
		document: citizenWithDentalAttendanceProcedures.cpf
			? formatIdentifier(citizenWithDentalAttendanceProcedures.cpf)
			: citizenWithDentalAttendanceProcedures.cns ?? "",
		motherName: citizenWithDentalAttendanceProcedures.motherName ?? "",
		phone: citizenWithDentalAttendanceProcedures.phone
			? phoneFormat(citizenWithDentalAttendanceProcedures.phone)
			: "",
		address:
			addressConcat(
				citizenWithDentalAttendanceProcedures.street,
				citizenWithDentalAttendanceProcedures.houseNumber,
				citizenWithDentalAttendanceProcedures.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsbB3CitizenHistoryInfo {...indicatorEsbB3CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Procedimentos Odontológicos"
				timeLineContents={(
					citizenWithDentalAttendanceProcedures.dentalAttendanceProcedures ?? []
				).map<TimeLineContent>((dentalAttendanceProcedure) => {
					return {
						content: (
							<IndicatorEsbB3DentalAttendanceProceduresHistoryItem
								dentalAttendanceProcedure={dentalAttendanceProcedure}
							/>
						),
						eventDate:
							timeDimensionToString(dentalAttendanceProcedure.timeDimensionId) ||
							"N/A",
					};
				})}
			/>
		</>
	);
}
